/* MAGIC */
export default function recursive(item, cb, result, name = "/", path = []) {
    if (item instanceof Object && cb(item, name, path, result) !== false) {
        Object.keys(item).forEach(key => recursive(item[key], cb, result, key, [...path, key]));
    }

    return result;
}